<ion-toolbar color="primary">
  <ion-title color="light20">Change Work?</ion-title>
</ion-toolbar>

<ion-content>
  <ion-grid>
    <ion-row class="ion-padding">
      <ion-text
      >Are you sure you want to change work to <strong>{{ name }}?</strong></ion-text
      >
    </ion-row>
    <div *ngIf="max - min >= 120000; else altText">
      <ion-row>
        <ion-col>
          <ion-label>
            <p class="time-display">{{ value | date: 'MMM d yyyy, h:mm a' }}</p>
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-range
          [min]="min"
          [max]="max"
          step="60000"
          [ngModel]="value"
          (ionInput)="onIonInput($event)"
          snaps="true"
        >
          <ion-button
            class="slider-btn"
            slot="start"
            size="small"
            fill="clear"
            (click)="bumpValue('-')"
            [disabled]="value <= min"
          >
            <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
          </ion-button>
          <ion-button
            class="slider-btn"
            slot="end"
            size="small"
            fill="clear"
            (click)="bumpValue('+')"
            [disabled]="value >= max"
          >
            <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
          </ion-button>
        </ion-range>
      </ion-row>
    </div>
    <ng-template #altText>
      <ion-row>
        <ion-text class="ion-padding">
          <i style="font-size: small">
            Time adjustment unavailable within the first 2 minutes of clock in.
            <b>This change will be applied to your current punch.</b>
          </i>
        </ion-text>
      </ion-row>
    </ng-template>
  </ion-grid>
</ion-content>

<ion-toolbar color="primary">
  <ion-buttons slot="end">
    <ion-button color="light40" fill="solid" (click)="closePopover('cancel')">
      <ion-icon color="warning" slot="start" name="arrow-undo-circle-outline"></ion-icon>
      <ion-text color="warning">Cancel</ion-text>
    </ion-button>
    <ion-button color="light40" fill="solid" (click)="closePopover('save')">
      <ion-icon color="success" slot="start" name="save-outline"></ion-icon>
      <ion-text color="success">Change</ion-text>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
